//#region src/isString.ts
/**
* Returns true if the value is a string
*
* @category Type Guards
*/
function isString(val) {
	return typeof val === "string";
}
var isString_default = isString;

//#endregion
export { isString_default };